import type { WarehouseRoutingFieldsFragment } from '@/graphql/fragments/orderWarehouseConfig.generated';

// The client twin of colugo's pickDefaultWarehouseId for one section of the
// order warehouse config, so a sidebar can show where "automatic" sends the
// order for the country currently in the form, before it is saved.
export function resolveAutomaticWarehouseUuid(
  config: WarehouseRoutingFieldsFragment,
  country: string | null | undefined,
): string {
  const code = country?.trim().toUpperCase();
  return (
    config.countries.find((c) => c.country_code === code)?.warehouse_uuid ??
    config.default_warehouse_uuid ??
    config.fallback_warehouse_uuid
  );
}

// The sidebar's warehouse selection: null is "automatic".
export function initialWarehouseSelection(order: {
  warehouse_uuid?: string | null;
  warehouse_is_automatic: boolean;
}): string | null {
  return order.warehouse_is_automatic ? null : (order.warehouse_uuid ?? null);
}
